(function pageSection($) {
  const targetIncludesCurrent = (targetBackground, currentBackground) => {
    // Turn a potentially comma-separated list into an array and see if the current
    // background of the page section is in that list.
    return targetBackground.split(',').includes(currentBackground);
  };

  const addClasses = (classesToAdd, currentBackground, $childToColourSwap) => {
    $.each(classesToAdd, function addClassesBasedOnPageSectionBg(
      targetBackground,
      classesToAdd,
    ) {
      if (targetIncludesCurrent(targetBackground, currentBackground)) {
        $childToColourSwap.addClass(classesToAdd);
      }
    });
  };

  const swapClasses = (swapsToMake, currentBackground, $childToColourSwap) => {
    $.each(swapsToMake, function loopThroughColourSwapSets(
      targetBackground,
      classesToSwap,
    ) {
      if (targetIncludesCurrent(targetBackground, currentBackground)) {
        $.each(classesToSwap, function swapColours(original, replacement) {
          if ($childToColourSwap.hasClass(original)) {
            $childToColourSwap.removeClass(original).addClass(replacement);
          }
        });
      }
    });
  };

  Drupal.behaviors.rutherfordPageSectionColourSwap = {
    attach(context) {
      const $childrenOfContextWithColoursToSwap = $(
        '[data-bg-swap-colours-background]',
        context,
      );

      const $parentsOfContextWithColoursToSwap = $(context).closest(
        '[data-bg-swap-colours-background]',
      );

      const $elementsWithColoursToSwap = $()
        .add($childrenOfContextWithColoursToSwap)
        .add($parentsOfContextWithColoursToSwap);

      $elementsWithColoursToSwap.each(function initSwapColours() {
        // Page sections that contain elements that need their classes swapping
        // should have a data attribute containing their current bg like the one below:
        // data-bg-swap-colours-background="blue"
        const currentBackground = $(this).data('bg-swap-colours-background');
        const hasDarkBg = $(this).hasClass('has-dark-bg');
        // Find elements within this page section that will need their colours
        // swapped.
        const $childrenToColourSwap = $(this).find(
          '[data-bg-swap-colours]:not([data-bg-classes-stop] [data-bg-swap-colours]),[data-bg-add-classes]:not([data-bg-classes-stop] [data-bg-add-classes])',
        );

        // Add a transition to smooth the colour changes just in case anyone is
        // watching really closely.
        $childrenToColourSwap.addClass('u-transition-all');

        // Start the process of swapping out the colours.
        $childrenToColourSwap.each(
          function loopThroughChildrenWithColoursToSwap() {
            const $childToColourSwap = $(this);
            // Load an object containing the classes to swap out for each background
            // colour. This comes from a data attribute like the one below:
            // data-bg-swap-colours='{"grey_gradient,white,light_grey": {"btn-light":"btn-primary"}}'
            const swapsToMake = $childToColourSwap.data('bg-swap-colours');
            // Instead of swapping, we can also add classes:
            // data-bg-add-classes='{"white,light_grey,grey_gradient": "u-border-1 u-border-grey-50"}'
            const classesToAdd = $childToColourSwap.data('bg-add-classes');

            addClasses(classesToAdd, currentBackground, $childToColourSwap);
            swapClasses(swapsToMake, currentBackground, $childToColourSwap);

            if (hasDarkBg) {
              addClasses(classesToAdd, 'has-dark-bg', $childToColourSwap);
              swapClasses(swapsToMake, 'has-dark-bg', $childToColourSwap);
            }
          },
        );
      });
    },
  };
})(jQuery);
